var map = {
	"./am.json": "8f9d",
	"./ar.json": "af08",
	"./bn.json": "8782",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fil.json": "cb49",
	"./fr.json": "f693",
	"./hi.json": "7a03",
	"./hmn.json": "97f7",
	"./ja.json": "0423",
	"./ko.json": "dd11",
	"./mh.json": "83f5",
	"./ms.json": "2060",
	"./my.json": "3ecc",
	"./ne.json": "ca97",
	"./pl.json": "89b2",
	"./pt.json": "5d67",
	"./ru.json": "7704",
	"./so.json": "eb3d",
	"./ur.json": "621c",
	"./vi.json": "aced",
	"./zh.json": "3504"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";